// PRC-048 (diseño 33, apartado 12): las opciones de «Próxima acción» del panel
// sustituyen al selector «Siguiente acción» también al editar la planificación
// de un expediente abierto. Una acción guardada con otro texto se muestra como
// «Otra acción» con su texto.
import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, InputBase } from '@mui/material';
import { J } from '../../../pricingJourney/journeyTokens';
import { NEXT_ACTIONS, OTHER_ACTION } from './cadenceManagementTexts';

const PRESETS = NEXT_ACTIONS.filter((a) => a !== OTHER_ACTION) as string[];

interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const NextActionChips: React.FC<Props> = ({ value, onChange, disabled }) => {
  const [other, setOther] = useState(Boolean(value) && !PRESETS.includes(value));
  useEffect(() => {
    if (value && !PRESETS.includes(value)) setOther(true);
  }, [value]);

  return (
    <Box sx={{ fontFamily: J.font }}>
      <Box sx={{ fontSize: 12, fontWeight: 700, color: J.body, mb: '6px' }}>Próxima acción</Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {NEXT_ACTIONS.map((label) => {
          const on = label === OTHER_ACTION ? other : !other && value === label;
          return (
            <ButtonBase
              key={label}
              disabled={disabled}
              aria-pressed={on}
              onClick={() => {
                if (label === OTHER_ACTION) {
                  setOther(true);
                  if (PRESETS.includes(value)) onChange('');
                } else {
                  setOther(false);
                  onChange(label);
                }
              }}
              sx={{
                border: '1px solid', borderColor: on ? J.sky : '#334155', borderRadius: 999, px: '12px', py: '5px',
                fontSize: 12.5, fontWeight: 600, fontFamily: J.font, color: on ? J.skyText : J.body,
                bgcolor: on ? 'rgba(56,189,248,.14)' : 'transparent',
              }}
            >
              {label}
            </ButtonBase>
          );
        })}
      </Box>
      {other && (
        <InputBase
          value={PRESETS.includes(value) ? '' : value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          placeholder="Describe la próxima acción"
          inputProps={{ 'aria-label': 'Otra acción', maxLength: 1000 }}
          sx={{ mt: '8px', width: '100%', border: '1px solid #334155', borderRadius: '10px', px: '12px', py: '7px', fontSize: 13.5, color: J.text, bgcolor: 'rgba(2,6,23,.5)', fontFamily: J.font }}
        />
      )}
    </Box>
  );
};

export default NextActionChips;
